"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// tslint:disable
// Remove this polyfill when all browsers we care about support Intl.pluralRules
// Remember to also then remove the dependency: @formatjs/intl-pluralrules
// See https://github.com/formatjs/react-intl/blob/master/docs/Upgrade-Guide.md#migrate-to-using-native-intl-apis
require("@formatjs/intl-pluralrules/locale-data/de");
require("@formatjs/intl-pluralrules/locale-data/en");
require("@formatjs/intl-pluralrules/locale-data/nb");
require("@formatjs/intl-pluralrules/locale-data/sr");
require("@formatjs/intl-pluralrules/locale-data/sv");
require("@formatjs/intl-pluralrules/locale-data/zh");
require("@formatjs/intl-pluralrules/polyfill");
require("@formatjs/intl-relativetimeformat/locale-data/de");
require("@formatjs/intl-relativetimeformat/locale-data/en");
require("@formatjs/intl-relativetimeformat/locale-data/nb");
require("@formatjs/intl-relativetimeformat/locale-data/sr");
require("@formatjs/intl-relativetimeformat/locale-data/sv");
require("@formatjs/intl-relativetimeformat/locale-data/zh");
// Remove this polyfill when all browsers we care about support Intl.relativeTimeformat
// Remember to also then remove the dependency: @formatjs/intl-relativetimeformat
require("@formatjs/intl-relativetimeformat/polyfill");
